<template>
    <div
        v-if="isShown"
        class="man"
        :style="style"
    >
        <div
            v-if="getIsTrackProgramsCompleted"
            class="info"
            @click="isPopupShown = !isPopupShown"
        ></div>
        <div
            class="popup"
            v-show="isPopupShown"
        >
            <UserPopupComplete
                v-if="getCompetencesForCoverTrack.length === 0"
            />
            <UserPopupCompetence
                v-else
                :items="getCompetencesForCoverTrack"
            />
            <Close
                class="close"
                @click="isPopupShown = false"
            />
        </div>
    </div>
</template>

<script>
import Close from '../../../UI/Close';
import UserPopupCompetence from './User/UserPopupCompetence';
import UserPopupComplete from './User/UserPopupComplete';
import {mapGetters} from 'vuex';

const getters = [
    'getIsTrackProgramsCompleted',
    'getCompetencesForCoverTrack',
];

export default {
    name: 'TimelineUserDesktop',
    components: {
        Close,
        UserPopupCompetence,
        UserPopupComplete,
    },
    props: {
        monthsToShow: {
            type: Number,
            required: true,
        },
        monthsOffset: {
            type: Number,
            required: true,
        },
        nowOffset: {
            type: Number,
            required: true,
        },
    },
    data: () => ({
        isPopupShown: false,
    }),
    computed: {
        ...mapGetters('accountTrack', getters),

        isShown() {
            return this.nowOffset > this.monthsOffset
                && this.nowOffset < this.monthsOffset + this.monthsToShow;
        },
        style() {
            return {
                left: `${(this.nowOffset - this.monthsOffset) / this.monthsToShow * 100}%`,
            };
        },
    },
};
</script>

<style lang="scss" scoped>
    @import '~@/styles/rem';

    .man {
        height: 344px;
        position: absolute;
        bottom: 0;
        width: 1px;
        &:before {
            pointer-events: none;
            display: block;
            height: 344px;
            content: " ";
            background-repeat: no-repeat;
            background-position: right bottom;
            background-image: url("../../../../assets/images/account-track/man.svg");
            min-width: 48px;
            position: absolute;
            left: -24px;
            z-index: 1;
        }
        .info {
            display: block;
            width: 32px;
            height: 32px;
            background-image: url("../../../../assets/images/account-track/info.svg");
            position: absolute;
            left: -16px;
            top: 56px;
            z-index: 1;
            cursor: pointer;
        }
        .popup {
            position: absolute;
            right: 20px;
            top: 56px;
            width: 320px;
            background: #FFFFFF;
            box-shadow: 0 2px 24px rgba(155, 161, 166, 0.6);
            border-radius: 4px;
            padding: 32px;
            user-select: none;
            z-index: 10;



            .close {
                position: absolute;
                top: 0;
                right: 0;
            }
        }
    }
</style>
